import ToolEntryButton from '~/components/toolbar/shared/ToolEntryButton';
import { useRegistrationModeEntries } from './useRegistrationModeEntries';

interface RegistrationModeToolProps {
    isDisabled: boolean;
    /** Why the modes are unavailable, appended to their tooltips while disabled. */
    disabledReason?: string;
    onModeSelected?: () => void;
}

export default function RegistrationModeTool({
    isDisabled,
    disabledReason,
    onModeSelected,
}: RegistrationModeToolProps) {
    const { translation, rotation } = useRegistrationModeEntries(
        isDisabled,
        disabledReason,
        onModeSelected
    );

    return (
        <>
            <ToolEntryButton
                entry={translation}
                data-testid="registration-translate-mode"
            />
            <ToolEntryButton
                entry={rotation}
                data-testid="registration-rotate-mode"
            />
        </>
    );
}
